module.exports = {"TXTCLI_LoadingXX":{"id":"TXTCLI_LoadingXX","defaultMessage":"Indlæser...","flags":["TRACK"],"track":"Loading..."}}